import React from "react";
import {
    UiCol,
    UiRowContainer,
} from "../../../components/grid-container/GridContainer";
import { UiSlider } from "../../../components/common/UiSlider";
import Nike from "../../../../../styles/img/favourites/nike.jpg";
import SliderHeart from "../../../../../styles/img/slider-heart-icon.png";
import {
    UiNextArrow,
    UiPrevArrow,
} from "../../../components/common/UiSliderArrows.jsx";
import {
    UiTopBgSliderLeftContent,
    UiTopShopBgSlider,
} from "../../../components/common/UiTopBgSliderElements";
import UiShopCard from "../../../components/cards/UiShopCard";

export default function ShopSlider(props) {
    const UiMainSlider = {
        dots: props.dots,
        infinite: true,
        speed: 500,
        slidesToShow: props.slidesToShow,
        slidesToScroll: 1,
        nextArrow: <UiNextArrow />,
        prevArrow: <UiPrevArrow />,
        responsive: [
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    infinite: true,
                },
            },
        ],
    };
    const learnMore = () => {
    };

    return (
        <>
            <UiTopShopBgSlider>
                <UiCol lg="7">
                    <UiTopBgSliderLeftContent>
                        <h2>
                            The Way To Add More Zing To Your Work{" "}
                            <img src={SliderHeart} />
                        </h2>
                        <p className="sb-top-bg-slider__slider-content__description">
                            You’re already working hard, enjoy the benefits of
                            various rewards you, your team and your family can
                            enjoy.
                        </p>
                    </UiTopBgSliderLeftContent>
                </UiCol>
                <UiCol lg="5" className="mt-3">
                    <UiSlider UiSliderSettings={UiMainSlider}>
                        <div className="sb-top-bg-slider__slider-wrapper ">
                            <UiRowContainer>
                                <UiCol lg="12">
                                    <UiShopCard
                                        cardImg={Nike}
                                        rating="4.41"
                                        reviews="47"
                                        heading="Manchester"
                                        points="345"
                                        remainingTime="16 hours left"
                                        body="From its medieval origins to the digital era, learn from its everything, From its past medieval. From medieval."
                                    />
                                </UiCol>
                            </UiRowContainer>
                        </div>
                        <div>
                            <UiRowContainer>
                                <UiCol lg="12">
                                    <UiShopCard
                                        cardImg={Nike}
                                        rating="4.41"
                                        reviews="47"
                                        heading="Manchester"
                                        points="345"
                                        remainingTime="16 hours left"
                                        body="From its medieval origins to the digital era, learn from its everything, From its past medieval. From medieval."
                                    />
                                </UiCol>
                            </UiRowContainer>
                        </div>
                        <div>
                            <UiRowContainer>
                                <UiCol lg="12">
                                    <UiShopCard
                                        cardImg={Nike}
                                        rating="4.41"
                                        reviews="47"
                                        heading="Manchester"
                                        points="345"
                                        remainingTime="16 hours left"
                                        body="From its medieval origins to the digital era, learn from its everything, From its past medieval. From medieval."
                                    />
                                </UiCol>
                            </UiRowContainer>
                        </div>
                    </UiSlider>
                </UiCol>
            </UiTopShopBgSlider>
        </>
    );
}
